import { Card, Stack } from '@mui/material'
import { memo } from 'react'
import { NavLink } from 'react-router-dom'

import MembershipLevel from '../staking/MembershipLevel'
import { STAKING_URL } from '../../constants/navigation'
import {
  formatCurrencyValue,
  percentageOfCompletion
} from '../../util/number.helpers'
import { findNextLevel } from '../../util/staking/staking.helpers'
import { formatTicks } from '../../util/string.helpers'
import SubmitButton from '../shared/button/SubmitButton'
import PurchaseStatusButton from '../shared/purchaseStatus/PurchaseStatusButton'

const NextLevelInfo = ({ t, totalFiatValue, tiers, isMobile }) => {
  const currentStakedValue = parseFloat(totalFiatValue || 0)
  const nextLevel = findNextLevel(currentStakedValue, tiers)
  const current = formatCurrencyValue(currentStakedValue, 2)
  const total = formatCurrencyValue(nextLevel?.fiatThreshold, 2)
  const btnSize = isMobile ? 'small' : 'large'
  return (
    <Card
      sx={{
        gap: 2,
        borderRadius: 1.5,
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: { xs: 'column', sm: 'row' }
      }}
    >
      <Stack spacing={1} width='100%' flex={1}>
        <MembershipLevel
          t={t}
          completed={percentageOfCompletion(current, total)}
          id={nextLevel?.id}
          title={t('membership.progress-towards-next-status')}
          label={t('brand:staking.dollar-value-of-staked', {
            value: formatTicks(current),
            total: formatTicks(total)
          })}
          height={10}
          progressTextSx={{ fontWeight: 600 }}
        />
      </Stack>
      <Stack spacing={2} direction='row'>
        <SubmitButton
          label={t('brand:staking.stake-more')}
          type='button'
          component={NavLink}
          to={STAKING_URL}
          size={btnSize}
        />
        <PurchaseStatusButton t={t} size={btnSize} />
      </Stack>
    </Card>
  )
}

export default memo(NextLevelInfo)
